'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Link } from '@/components/ui/link';
import { HEADER_LINKS } from '@/constants/navigation';
import { usePathname } from '@/i18n/routing';
export function Navbar() {
  const $ = _c(5);
  const pathname = usePathname();
  const t = useTranslations();
  let t0;
  if ($[0] !== pathname || $[1] !== t) {
    t0 = HEADER_LINKS.map(link => <li key={link.href}><Link href={link.href} data-active={pathname === link.href} className="px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground data-active:text-foreground">{t(link.labelKey)}</Link></li>);
    $[0] = pathname;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <nav className="hidden md:block"><ul className="flex items-center gap-2">{t0}</ul></nav>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}